import apiClient from "./config";
import { COMPARISON_ENDPOINTS } from "./endpoints/comparisonEndpoints";

const ComparisonService = {
  compare: (data) => {
    return apiClient.post(COMPARISON_ENDPOINTS.COMPARE, data);
  },
  publicCompare: (data) => {
    return apiClient.post(COMPARISON_ENDPOINTS.PUBLICCOMPARE, data);
  },
  filter: (data) => {
    return apiClient.post(COMPARISON_ENDPOINTS.FILTER, data);
  },
  CompareCity: (data) => {
    return apiClient.post(COMPARISON_ENDPOINTS.COMPARE_CITY, data);
  },
  CompareCityOnly: (data) => {
    return apiClient.post(COMPARISON_ENDPOINTS.COMPARE_CITY_ONLY, data);
  },
  UpdateUser: (data) => {
    return apiClient.post(COMPARISON_ENDPOINTS.UPDATE_USER, data);
  },
  userCity: () => {
    return apiClient.get(COMPARISON_ENDPOINTS.USER_CITY);
  },
  hospitalInfo: (params) => {
    return apiClient.get(COMPARISON_ENDPOINTS.HOSPITAL_INFO, { params });
  },
  hospitalInfoPublic: (params) => {
    return apiClient.get(COMPARISON_ENDPOINTS.HOSPITAL_INFO_PUBLIC, { params });
  },
  hospitalInfoCount: (params) => {
    return apiClient.get(COMPARISON_ENDPOINTS.HOSPITAL_INFO_COUNT, { params });
  },
  changeSalary: (data) => {
    return apiClient.post(COMPARISON_ENDPOINTS.CHANGE_SALARY, data);
  },
  comapreCityCount: (data) => {
    return apiClient.post(COMPARISON_ENDPOINTS.CHECK_COMPARE_COUNT, data);
  },
  mapAnalytics: (data) => {
    return apiClient.post(COMPARISON_ENDPOINTS.MAP_ANALYTICS, data);
  },
};

export default ComparisonService;
